
import { mapState } from 'vuex';
import ProductCard from '@/components/catalog/productCard';
import LazyLoader from '@/components/elements/LazyLoader';
import Banner from '~/components/catalog/banner';
import activeVideo from '~/mixins/activeVideo';
import PreOrderModal from '~/components/catalog/product/PreOrderModal.vue';

export default {
  name: 'ProductsLazyLoad',
  components: {
    Banner,
    ProductCard,
    LazyLoader,
    PreOrderModal,
  },
  mixins: [ activeVideo ],
  layout: 'main',
  props: {
    products: {
      type: Object,
      required: true,
    },
    infinite: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isPending: false,
      bannerRatio: {
        pc: '100%',
        mobile: '100%',
      },
      preOrderModal: false,
      preOrderProduct: null,
    }
  },
  computed: {
    ...mapState('cart', ['addingCartLoading']),
    canGetNextPage() {
      if (!this.infinite) return false

      return this.products.items.length < this.products.range;
    },
    mqIsMobile() {
      return this.$mq === 'mobileXs' || this.$mq === 'mobile' || this.$mq === 'tablet';
    },
  },
  watch: {
    products: {
      handler() {
        this.isPending = false;
      },
      deep: true,
    },
  },
  methods: {
    onLoaderUpdate() {
      this.isPending = true;
      this.$emit('get-items');
    },
    onToggleFavorite(id) {
      if (!this.mqIsMobile) {
        this.$emit('toggle-favorite', id);
      }
    },
  },
};
